import React, { useState, useEffect } from "react";
import "./SummariesTab.scss";
import SummaryItem from "./SummaryItem";
import SummariesIcon from "assets/icons/summariesIcon.png";
import SummaryOverlay from "../SummaryOverlay";
import MobileModal from "../MobileModal";
import { showMobile } from "helpers/adaptation";
import { useLocation } from "react-router-dom";

interface Props {
  data?: any[];
  searchData?: any[];
  isFirstTab?: boolean;
  searchText?: string;
  valKey?: any;
}

function SummariesTab({ data, searchData, isFirstTab, searchText }: Props) {
  const [selectedCourse, setSelectedCourse] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (showModal) {
      setShowModal(false);
      setTimeout(() => {
        setSelectedCourse(null);
      }, 300);
    }
  }, [location.state?.resetModal]);

  const handleCourseClick = (course: any) => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedCourse(null);
    }, 300);
  };

  return (
    <div
      className={`SummariesTab-main ${isFirstTab ? "FirstTab-main" : ""} ${
        showModal ? "hide-scroll" : ""
      }`}>
      <div className="SummariesTab-ul">
        {searchData && searchText && (
          <div className="summariesTab-ul-container summariesTab-ul-container-search">
            <div>
              {searchData.map((val, index) => {
                if (val === null) {
                  return null;
                }

                const isDisabled =
                  val.Locked === true || (typeof val?.isEnabled === "boolean" && !val?.isEnabled);

                return (
                  <div key={`${val.Id}_${index}`} className="list-item-courses-summary">
                    <SummaryItem
                      onPressItem={!isDisabled ? () => handleCourseClick(val) : undefined}
                      title={val.Name}
                      img={SummariesIcon}
                      isLocked={isDisabled}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {searchText?.length === 0 && (
          <div
            className="summariesTab-ul-container"
            style={{
              justifyContent: "flex-start"
            }}>
            {data?.map((itemCourse, index) => {
              return (
                <div key={`${index}_${itemCourse?.Index}`}>
                  {itemCourse?.courses?.map((val: any, indexItemCourse: number) => {
                    if (val === null) {
                      return (
                        <div
                          key={indexItemCourse}
                          className="list-item-courses-summary"
                          style={{ opacity: 0 }}></div>
                      );
                    }

                    const isDisabled =
                      val.Locked === true ||
                      (typeof val?.isEnabled === "boolean" && !val?.isEnabled);

                    return (
                      <div key={indexItemCourse} className="list-item-courses-summary">
                        <SummaryItem
                          onPressItem={!isDisabled ? () => handleCourseClick(val) : undefined}
                          title={val.Name}
                          img={SummariesIcon}
                          isLocked={isDisabled}
                        />
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}
      </div>
      {selectedCourse && (
        <>
          {showMobile ? (
            <MobileModal
              show={showModal}
              onHide={handleCloseModal}
              htmlContent={selectedCourse.SEODescription || ""}
              title={selectedCourse.Name}
            />
          ) : (
            <SummaryOverlay
              show={showModal}
              onHide={handleCloseModal}
              htmlContent={selectedCourse.SEODescription || ""}
              title={selectedCourse.Name}
            />
          )}
        </>
      )}
    </div>
  );
}

export default SummariesTab;
